import { TextField } from '@mui/material';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import { Unavailability } from '@thro-types/leihbar';

import { FocusEventHandler } from 'react';

import { CustomPickersDay } from '../../ProductDetailPage/components/CustomPickersDay';

interface Props extends Omit<DateTimePickerProps<Date, Date>, 'renderInput'> {
  type: 'START' | 'END';
  error: boolean | undefined;
  helperText: string | undefined;
  value: Date;
  minDateTime: Date;
  maxDateTime?: Date;
  unavailabilities: Unavailability[];
  onBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
}

export const AvailabilityDateTimePicker = ({
  type,
  error,
  helperText,
  value,
  onChange,
  onOpen,
  minDateTime,
  maxDateTime,
  shouldDisableTime,
  shouldDisableDate,
  unavailabilities,
  onBlur
}: Props) => {
  const getId = (type: 'START' | 'END') => {
    if (type === 'START') {
      return 'startTime';
    }
    return 'endTime';
  };

  return (
    <DateTimePicker
      renderInput={props => (
        <TextField
          {...props}
          id={getId(type)}
          name={getId(type)}
          variant="outlined"
          error={error}
          helperText={helperText}
          onBlur={onBlur}
          size="small"
        />
      )}
      value={value}
      onChange={onChange}
      onOpen={onOpen}
      mask="__.__.____ __:__"
      minDateTime={minDateTime}
      maxDateTime={maxDateTime}
      inputFormat="dd.MM.yyyy HH:mm"
      ampm={false}
      ampmInClock={false}
      minutesStep={15}
      shouldDisableDate={shouldDisableDate}
      shouldDisableTime={shouldDisableTime}
      PopperProps={{
        sx: {
          '.MuiClockNumber-root': {
            '&.Mui-disabled': { opacity: 0.6 },
            ':not(.Mui-disabled)': {
              fontWeight: 650
            }
          }
        }
      }}
      InputProps={{ onKeyDown: e => e.preventDefault() }}
      renderDay={(day, selectedDays, pickersDayProps) => (
        <CustomPickersDay
          day={day}
          selectedDays={selectedDays}
          pickersDayProps={pickersDayProps}
          unavailabilities={unavailabilities}
          key={day.toString()}
        />
      )}
    />
  );
};
